import { get } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { useAppContext } from '../../../context/context';
import EditModal from '../../common/modal/EditModal';
import RowDisplay from '../../common/RowDisplay';
import replaceAndCapitalizeString from '../../utils/replaceAndCapitalizeString';
import { getGender } from '../../utils/gender';
import findEnumDisplayName from '../../../constants/findEnumDisplayName';
import IdentifiesAsForm from './IdentifiesAsForm';
import enums from '../../../constants/enums';
function IdentifiesAsDisplay(props) {
  var contact = props.contact,
    limitedGenderOptions = props.limitedGenderOptions;
  var _useAppContext = useAppContext(),
    fieldsConfig = _useAppContext.state.fieldsConfig;
  var editSection = /*#__PURE__*/React.createElement(EditModal, {
    header: "Edit Identify As",
    size: "large",
    formName: "edit-identify-as",
    editButtonId: "edit-identity-btn",
    id: "edit-identity-modal",
    showEdit: get(fieldsConfig, 'identifiesAsSection.showEdit')
  }, /*#__PURE__*/React.createElement(IdentifiesAsForm, {
    contact: contact,
    limitedGenderOptions: limitedGenderOptions
  }));
  return /*#__PURE__*/React.createElement(RowDisplay, {
    editSection: editSection,
    label: "Identifies As"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Race"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "race-display"
  }, contact.race ? replaceAndCapitalizeString(contact.race) : '--')), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Ethnicity"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "ethnicity-display"
  }, contact.ethnicity ? replaceAndCapitalizeString(contact.ethnicity) : '--')), /*#__PURE__*/React.createElement("div", {
    className: "col-sm-4"
  }, /*#__PURE__*/React.createElement("p", {
    className: "subhead"
  }, "Gender"), /*#__PURE__*/React.createElement("p", {
    "data-test-element": "gender-display"
  }, findEnumDisplayName(enums.people.genders, getGender({
    gender: contact.gender,
    flag: limitedGenderOptions
  })))));
}
IdentifiesAsDisplay.propTypes = {
  contact: PropTypes.object.isRequired
};
export default IdentifiesAsDisplay;
//# sourceMappingURL=IdentifiesAsDisplay.js.map